import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";

import { useActiveProfile } from "@/providers/ActiveProfileProvider";
import { useBetaInformation } from "@/hooks/queries/useBetaInformation";
import { useMySubscription } from "@/hooks/queries/useMySubscription";
import { SURETY_PLAN_NAME } from "@/lib/domain-constants";

// Quien salió por la válvula (falló la IA o el guardado) no vuelve a ser
// redirigido en esta pestaña; al recargar, el onboarding se le pide otra vez.
let escapedThisSession = false;

export function markOnboardingEscaped() {
  escapedThisSession = true;
}

/**
 * Manda al onboarding a quien todavía no lo hizo, con las mismas condiciones con
 * las que antes se abría solo el modal: beta aceptada y vigente, y sin haberlo
 * visto.
 */
export function OnboardingRedirect() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { data: beta } = useBetaInformation();
  const { isLoading: profilesLoading } = useActiveProfile();
  const { data: subscription } = useMySubscription();

  // Fianzas no tiene líneas de negocio: el onboarding de proveedor no le aplica.
  const pending =
    subscription?.planKey !== SURETY_PLAN_NAME &&
    !!beta?.userextrainformation_betaformcompleted &&
    !!beta?.userextrainformation_betaaccepted &&
    !beta?.betaexpired &&
    !beta?.userextrainformation_introseenat &&
    !profilesLoading;

  useEffect(() => {
    if (!pending || escapedThisSession || pathname === "/onboarding") return;
    navigate("/onboarding", { replace: true });
  }, [pending, pathname, navigate]);

  return null;
}
